module.exports = __webpack_public_path__ + "static/media/remove.035412bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/remove.svg
// module id = 1139
// module chunks = 1